module.exports = __webpack_public_path__ + "static/media/spark-bolt.81730a40.png";